export class Address {
  addressLine: string;
  city: string;
  state: string;
  country: string;
  postCode: string;
  email: string;
  telephone: string;
  mobile: string;

  clear() {
    this.addressLine = '';
    this.city = '';
    this.state = '';
    this.country = '';
    this.postCode = '';
    this.email = '';
    this.telephone = '';
    this.mobile = '';
  }
}
